import { render, staticRenderFns } from "./MessageJump.vue?vue&type=template&id=31254f72&scoped=true&"
import script from "./MessageJump.vue?vue&type=script&lang=js&"
export * from "./MessageJump.vue?vue&type=script&lang=js&"
import style0 from "./MessageJump.vue?vue&type=style&index=0&id=31254f72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31254f72",
  null
  
)

export default component.exports